import type { MetricBarMap } from "./types";

export const PERCENT = "percent";

export const metricBarNameMap: MetricBarMap = {
    traffic_share: "analysis.source.search.keywords.header.metrics.searchVisits",
};
